import { UIHeading4, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './ChatListChatbotItem.css';
// @ts-expect-error TODO: исправить импорт картинок
import avatar from './assets/avatar.png';

interface IChatListChatbotItemProps {
  onClick(): void;
  isActive?: boolean;
  text?: string;
  unreadCount?: number;
}

export const ChatListChatbotItem = ({
  onClick,
  unreadCount = 0,
  isActive = false,
  text,
}: IChatListChatbotItemProps) => {
  return (
    <div className={`${styles['item']} ${isActive ? styles['_active'] : ''}`} onClick={onClick} data-chatid="">
      <img className={styles['preview-image']} src={avatar} alt={'Циан-помощник'} />

      <div className={styles['details']}>
        <div className={styles['texts']}>
          <UIHeading4 whiteSpace="nowrap">Циан-помощник</UIHeading4>
          {text && <UIText1 color="gray60_100">{text}</UIText1>}
        </div>

        {unreadCount !== 0 && (
          <span data-testid="unreadCounter" className={styles['counter']}>
            {unreadCount}
          </span>
        )}
      </div>
    </div>
  );
};
